var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7971_152796)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13C20 13.6944 19.9115 14.3682 19.7452 15.0107C19.8292 15.0036 19.9142 15 20 15C20.623 15 21.2016 15.1899 21.6811 15.5149C21.8893 14.7114 22 13.8686 22 13C22 8.5033 19.032 4.69982 14.9481 3.44167C14.9822 3.62257 15 3.80921 15 4C15 4.52294 14.8662 5.01462 14.631 5.44269C17.7568 6.53078 20 9.50342 20 13ZM9.36904 5.44269C9.1338 5.01462 9 4.52294 9 4C9 3.8092 9.01781 3.62257 9.05186 3.44167C4.968 4.69981 2 8.5033 2 13C2 13.8686 2.11075 14.7114 2.31889 15.5149C2.79844 15.1899 3.37705 15 4 15C4.08582 15 4.1708 15.0036 4.25479 15.0107C4.08848 14.3682 4 13.6944 4 13C4 9.50342 6.24322 6.53078 9.36904 5.44269ZM12 21C13.9853 21 15.8017 20.2768 17.2001 19.0796C17.4481 19.7223 17.911 20.2581 18.5007 20.599C16.7525 22.0959 14.4819 23 12 23C9.51815 23 7.24746 22.0959 5.49935 20.599C6.08904 20.2581 6.55192 19.7223 6.79989 19.0796C8.19832 20.2768 10.0147 21 12 21Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15C2.34315 15 1 16.3431 1 18C1 19.6569 2.34315 21 4 21C5.65685 21 7 19.6569 7 18C7 16.3431 5.65685 15 4 15Z",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15C18.3431 15 17 16.3431 17 18C17 19.6569 18.3431 21 20 21C21.6569 21 23 19.6569 23 18C23 16.3431 21.6569 15 20 15Z",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1C10.3431 1 9 2.34314 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1Z",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7971_152796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionIcon);
export default __webpack_public_path__ + "static/media/connection_icon.3a55f7368b3906a62c660a9738f2942d.svg";
export { ForwardRef as ReactComponent };